module.exports = __webpack_public_path__ + "img/blaz-register.30e87e55.png";